/* eslint-disable @typescript-eslint/no-namespace */

namespace WindowUtil {
  export type Location = {
    hash: string;
  };

  export function scrollToID(id: string): void {
    const target = document.getElementById(id);

    if (target !== null) {
      const clientRect = target.getBoundingClientRect();

      window.scrollTo({
        top: window.pageYOffset + clientRect.top,
        left: window.pageXOffset + clientRect.left,
        behavior: 'smooth',
      });
    }
  }

  /** URL のハッシュがあればその位置までスクロールし、なければページトップまでスクロールする。 */
  export function scrollToHashOrTop(location: Location): void {
    const hash = location.hash;
    if (hash) {
      try {
        const decoded = decodeURI(hash.replace(/^#/, ''));
        if (decoded) {
          WindowUtil.scrollToID(decoded);
        }
      } catch (e) {
        if (e instanceof URIError) {
          window.scrollTo(0, 0);
        }
      }
    } else {
      window.scrollTo(0, 0);
    }
  }
}

export default WindowUtil;
